/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UnprocessableEntity.ts
 */

import APIError from "./APIError";

export default class UnprocessableEntity extends APIError {
    constructor(message: string) {
        super("Requête non interprétable par le serveur", 422, message);
    }
}